import React from 'react';
import TextField from 'fe-design-base/molecules/TextField';

import { toI18n } from 'util/i18n';
const NewPasswordField = () => (
  <TextField
    name="password"
    label={toI18n('authentication.forgot_password.new.label')}
    type="password"
    fullWidth
    dataTestId="NewPasswordField"
    startIcon="Lock"
    trim
  />
);

export default NewPasswordField;
